import { useQuery } from "@apollo/client";
import { MY_HR_GET_CHANGE_REQUESTS_ATTACHEMENT } from "my-hr/graphql";

export const useMyHrChangeRequestAttachement = (
  type: string,
  employeeCode: string,
) => {
  const { data, loading, error, refetch } = useQuery(
    MY_HR_GET_CHANGE_REQUESTS_ATTACHEMENT,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        employeeCode,
        type,
      },
    },
  );

  const result = data?.listAttachementByEmployee || [];
  return {
    data: result,
    loading,
    error,
    refetch,
  };
};

export default useMyHrChangeRequestAttachement;
